import React, { useEffect } from 'react';
import { toast } from 'sonner';
const names = ['Marco', 'Giulia', 'Alessandro', 'Chiara', 'Lorenzo', 'Valentina', 'Matteo', 'Sara', 'Andrea', 'Elena', 'Davide', 'Martina', 'Simone', 'Federica', 'Luca'];
const cities = ['Roma', 'Milano', 'Napoli', 'Torino', 'Firenze', 'Bologna', 'Palermo', 'Genova', 'Verona', 'Padova', 'Bari', 'Catania', 'Venezia', 'Trieste', 'Perugia'];
export function PurchasePopup() {
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      toast.custom(t => <div className="bg-white p-3 rounded-lg shadow-xl border border-gray-100 flex items-center space-x-4 max-w-sm animate-in slide-in-from-bottom-5" data-id="element-205">
            <img src="https://cdn.magicpatterns.com/uploads/tjgkzNkd3KeZC2JTS9FMDA/Tomo_1.png" alt="Product" className="w-12 h-16 object-cover rounded shadow-sm" data-id="element-206" />
            <div data-id="element-207">
              <p className="text-sm text-gray-800 font-medium" data-id="element-208">
                <span className="font-bold" data-id="element-209">{randomName}</span> da {randomCity}
              </p>
              <p className="text-xs text-green-600 font-semibold mt-1" data-id="element-210">
                Ha appena acquistato questo prodotto
              </p>
            </div>
          </div>, {
        duration: 4000,
        position: 'bottom-left'
      });
      // Schedule next popup between 15 and 30 seconds
      const nextDelay = Math.floor(Math.random() * (30000 - 15000 + 1) + 15000);
      timeoutId = setTimeout(showPopup, nextDelay);
    };
    // Initial delay before first popup
    let timeoutId = setTimeout(showPopup, 10000);
    return () => clearTimeout(timeoutId);
  }, []);
  return null;
}